import React, { Component, useEffect, useLayoutEffect, useState } from "react";
import Office from "../../models/Office";
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";

export type OfficeMapViewProps = {
  offices: Office[];
  translations: {
    routeDescription: string;
    sendMail: string;
  }
}

export const googleMapUrl =
  "https://maps.googleapis.com/maps/api/js?key=AIzaSyAWAxBgAwZlbMZDyH9UB7uFtu0jjxdnj0M";

const OfficesMapViewComponent = (props: OfficeMapViewProps) => {
  const [selectedOffice, setSelectedOffice] = useState<Office>();

  useEffect(() => {
    const listener = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setSelectedOffice(undefined);
      }
    };

    window.addEventListener("keydown", listener);
    return () => window.removeEventListener("keydown", listener);
  }, []);

  function getRouteUrl(office: Office) {
    return `https://maps.google.com/?daddr=${office.street}+${office.houseNumber},+${office.postalCode}+${office.city}`;
  }

  return (
    <GoogleMap
      mapContainerStyle={{ height: "50vh" }}
      zoom={8}
      center={{ lat: 50.8550625, lng: 4.3053505 }}
      options={{
        disableDefaultUI: true,
        gestureHandling: "cooperative",
        styles: [
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "administrative.neighborhood",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "poi",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "labels",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road.local",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "transit",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
        ],
      }}
    >
      {props.offices.map((office: Office, index: number) => {
        return (
          office.longitude &&
          office.longitude !== 0 &&
          office.latitude &&
          office.latitude !== 0 && (
            <div className="col-4" key={index}>
              <Marker
                position={{ lat: office.latitude, lng: office.longitude }}
                icon={{
                  url: "/img/svg/maps_marker.svg",
                  anchor: new google.maps.Point(5, 58),
                }}
                onClick={() => setSelectedOffice(office)}
              >
                {office === selectedOffice && (
                  <InfoWindow
                    onCloseClick={() => {
                      setSelectedOffice(undefined);
                    }}
                    position={{
                      lat: office.latitude,
                      lng: office.longitude,
                    }}
                  >
                    <div className="text-medium infobox">
                      <div className="text-large font-weight-bold text-secondary mb-2">
                        {office.name}
                      </div>
                      <div>{office.street}</div>
                      <div className="mb-2">
                        {office.postalCode} {office.city}
                      </div>
                      <div className="pb-2 mb-2 border-bottom">
                        <a className="text-underline" href={getRouteUrl(office)} target="_blank" rel="noopener noreferrer">
                          {props.translations.routeDescription}
                        </a>
                      </div>
                      <ul className="mb-1">
                        {office.telephone && <li>
                          <a className="text-underline" href={`tel:${office.telephone}`}>
                            {office.telephone}
                          </a>
                        </li>}
                        {office.email && <li>
                          <a className="text-underline" href={`mailto:${office.email}`}>
                            {props.translations.sendMail}
                          </a>
                        </li>}
                      </ul>
                    </div>
                  </InfoWindow>
                )}
              </Marker>
            </div>
          )
        );
      })}
    </GoogleMap>
  );
};

export default function OfficesMapView(props: OfficeMapViewProps) {
  const containerElement = <div style={{ height: "50vh" }} />;
  const mapElement = <div style={{ height: "50vh" }} />;

  return <OfficesMapViewComponent {...props} />;
}
